// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-banner__wrapper.mocked[data-v-5f148b1a]{position:relative;background:#a363ff;height:100%;height:300px}.video-banner__wrapper.mocked[data-v-5f148b1a]:after{content:\"Video Banner\";color:#fff;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);font-size:16px;font-weight:700}@media (max-width:767px){.video-banner__wrapper.mocked[data-v-5f148b1a]:after{font-size:12px}}", ""]);
// Exports
module.exports = exports;
